import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCh = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0h32v32H0z", fill: "#da291c" }), /* @__PURE__ */ React.createElement("path", { d: "M13 6h6v7h7v6h-7v7h-6v-7H6v-6h7z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgCh);
const Memo = memo(ForwardRef);
export default Memo;
